
import {useEffect, useRef, useState} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';
import ConfirmDialog from '@/components/ConfirmDialog';
import Text, {TextType, TextColor} from '@/components/Text';
import {DialogBody, DialogFoot} from '@/components/Dialog';
import styles from './index.module.scss';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import Icon, {IconSize} from '@/components/Icon';
import {NoteTipSvg} from '@/icons';
import sdk from '@/sdk';
import {SidebarSearchList} from './components/listNew';


interface AllRecentBrowseRecords {
    isOpenAllRecentBrowseRecords: boolean;
    pageView?: number;
    setIsOpenAllRecentBrowseRecords: React.Dispatch<React.SetStateAction<boolean>>;
    docGuid: string | undefined;
    repositoryGuid: string;
}

function RecentBrowseRecordsConfirmDialog(props: AllRecentBrowseRecords) {
    const {
        isOpenAllRecentBrowseRecords,
        pageView,
        docGuid,
        setIsOpenAllRecentBrowseRecords,
        repositoryGuid,
    } = props;
    const [list, setList] = useState<any[]>([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const needReport = useRef(false);
    const [closeRecentBrowseRecords, setcloseRecentBrowseRecords] = useState(false);

    function resetStatus() {
        setList([]);
        setError(false);
    }

    // 获取浏览记录
    async function recentBrowseRecords() {
        if (repositoryGuid) {
            setLoading(true);
            const data = {
                docGuid,
                repositoryGuid: repositoryGuid,
            };
            try {
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getRecentBrowseRecords(data);
                setError(false);
                setLoading(false);
                if (result.data) {
                    setList(result.data);
                }
            } catch (error) {
                if (error.code === 400) {
                    setcloseRecentBrowseRecords(true);
                } else {
                    setError(true);
                    setList([]);
                    console.log(error);
                }
            } finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        isOpenAllRecentBrowseRecords && recentBrowseRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenAllRecentBrowseRecords]);


    function handleCancel() {
        setIsOpenAllRecentBrowseRecords(false);
        resetStatus();
    }

    function handReload() {
        recentBrowseRecords();
    }

    return (
        <>
            <ConfirmDialog
                className={styles.root}
                headline={
                    <Text type={TextType.T16} color={TextColor.Dark} className={styles.headline}>
                        <FormattedMessage id={'recentBrowseRecordsConfirmDialog'} />
                        <Tooltip
                            trigger={TooltipTrigger.Hover}
                            content={'仅展示近6个月详情，仅管理员和可编辑成员可见'}
                            className={styles.toolTip}
                            placement={'top'}
                        >
                            {/* 修改图标大小与字体距离 */}
                            <Icon svg={NoteTipSvg} size={IconSize.SM} className={styles.icon} />/
                        </Tooltip>
                    </Text>
                }
                visible={isOpenAllRecentBrowseRecords}
                // visible={testVisible}
                onCancel={handleCancel}
                showCloseX
                showHeader
            >
                <DialogBody>
                    <div className={styles.confirmContent}>
                        <div className={styles.repositoriesList}>
                            <SidebarSearchList
                                list={list}
                                reload={handReload}
                                error={error}
                                loading={loading}
                                pageView={pageView}
                                closeRecentBrowseRecords={closeRecentBrowseRecords}
                            />
                        </div>
                    </div>
                </DialogBody>
                <DialogFoot />
            </ConfirmDialog>
        </>
    );
}

export default RecentBrowseRecordsConfirmDialog;

